import React from 'react';
import { usePermissions } from '../../contexts/PermissionContext';

/**
 * Component that conditionally renders children based on permissions
 * 
 * Usage:
 * <PermissionGate permission="edit_booking">
 *   <button>Edit</button>
 * </PermissionGate>
 * 
 * <PermissionGate permissions={['edit_booking', 'delete_booking']} requireAll>
 *   <button>Edit & Delete</button>
 * </PermissionGate>
 */
const PermissionGate = ({ 
  permission, 
  permissions, 
  requireAll = false, 
  fallback = null,
  children 
}) => {
  const { hasPermission, hasAnyPermission, hasAllPermissions, loading } = usePermissions();

  if (loading) {
    return fallback;
  }

  let hasAccess = false;

  if (permission) {
    // Single permission check
    hasAccess = hasPermission(permission);
  } else if (permissions && permissions.length > 0) {
    // Multiple permissions check
    hasAccess = requireAll 
      ? hasAllPermissions(permissions)
      : hasAnyPermission(permissions);
  } else {
    // No permissions specified, allow access
    hasAccess = true;
  }

  return hasAccess ? children : fallback;
};

export default PermissionGate;
